import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import DeleteReportExportForm from './form'

const DeleteReportExportDialog = React.forwardRef(function ModifyReportAttributesDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (report) => {
      setDialogState({ open: true, processing: false, report })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Delete Denali View Export Configuration'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DeleteReportExportForm
            report={dialogState.report}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteReportExportDialog.propTypes = {
  onComplete: PropTypes.func
}

DeleteReportExportDialog.defaultProps = {
  onComplete: () => {}
}

export default DeleteReportExportDialog
